export const Pokedex: {[k: string]: ModdedSpeciesData} = {
	cresceidon: {
		inherit: true,
		baseStats: {hp: 80, atk: 32, def: 111, spa: 88, spd: 99, spe: 125},
		abilities: {0: "Multiscale", 1: "Rough Skin"},
		eggGroups: ["Undiscovered"],
	},
};
